var App = App || {};

App.SiteHeader = (function () {
    "use strict";

    const OFFCANVAS_ACTIVE_CLASS = 'offcanvas-active';

    function init() {
        Search();
        UtilityNavigationDropdowns();
        MinimalNavigation();
        MobileMenu();
        bindOffcanvasStateHandlers();
        syncOffcanvasState();
    }

    function isAnyOffcanvasOpen() {
        return document.querySelector('.offcanvas.show') !== null;
    }

    function syncOffcanvasState() {
        document.body.classList.toggle(OFFCANVAS_ACTIVE_CLASS, isAnyOffcanvasOpen());
    }

    function bindOffcanvasStateHandlers() {
        document.addEventListener('shown.bs.offcanvas', syncOffcanvasState);
        document.addEventListener('hidden.bs.offcanvas', syncOffcanvasState);
    }

    function Search() {
        const searchOffcanvas = document.getElementById("site-header-search-offcanvas");
        if (!searchOffcanvas) return;

        const searchTextField = searchOffcanvas.querySelector("input[type='text'].form-control");

        searchOffcanvas.addEventListener("shown.bs.offcanvas", function () {
            if (searchTextField) {
                searchTextField.focus();
            }
        });
    }

    function UtilityNavigationDropdowns() {
        const utilityNav = document.querySelector('.site-header-utility-nav');
        if (!utilityNav) return;

        utilityNav.addEventListener('show.bs.dropdown', function (e) {
            const currentToggle = e.target;
            if (!currentToggle || !currentToggle.matches('[data-bs-toggle="dropdown"]')) return;

            utilityNav.querySelectorAll('[data-bs-toggle="dropdown"].show').forEach(function (openToggle) {
                if (openToggle === currentToggle) return;

                const dropdownInstance = bootstrap.Dropdown.getInstance(openToggle);
                if (dropdownInstance) {
                    dropdownInstance.hide();
                }
            });
        });
    }

    // Minimal JS - handles class toggling for CSS-driven hover effects
    // All visual effects (animations, transitions) are handled by SCSS
    function MinimalNavigation() {
        const mainMenuItems = document.querySelectorAll('.main-menu-item.has-children');
        const innerMenuWraps = document.querySelectorAll('.inner-menu-wrap');
        const hoverOpenDelay = 200;
        const hoverCloseDelay = 300;
        let activeMenuTimeout = null;
        let pendingOpenTimeout = null;

        function openMenu(menuItem) {
            const menuWrap = menuItem.querySelector('.inner-menu-wrap');

            mainMenuItems.forEach(function(item) {
                if (item !== menuItem) {
                    item.classList.remove('hover');
                    const wrap = item.querySelector('.inner-menu-wrap');
                    if (wrap) wrap.classList.remove('level1-visible');
                }
            });

            menuItem.classList.add('hover');
            if (menuWrap) {
                menuWrap.classList.remove('level1-hidden');
                menuWrap.classList.add('level1-visible');
            }

            // Open only the level 1 panel; do not auto-activate a level 2 panel
            resetInnerMenuSelection(menuWrap);
        }

        // Handle main menu item hover to show mega menu
        mainMenuItems.forEach(function(menuItem) {
            menuItem.addEventListener('mouseenter', function() {
                if (isAnyOffcanvasOpen()) return;

                clearTimeout(activeMenuTimeout);
                clearTimeout(pendingOpenTimeout);

                pendingOpenTimeout = setTimeout(function() {
                    openMenu(menuItem);
                }, hoverOpenDelay);
            });

            // Handle mouseleave with delay
            menuItem.addEventListener('mouseleave', function() {
                const menuWrap = this.querySelector('.inner-menu-wrap');
                const menuItemElement = this;

                clearTimeout(pendingOpenTimeout);

                activeMenuTimeout = setTimeout(function() {
                    menuItemElement.classList.remove('hover');
                    if (menuWrap) {
                        menuWrap.classList.remove('level1-visible');
                        menuWrap.classList.add('level1-hidden');
                    }
                }, hoverCloseDelay); // Delay to allow moving to submenu
            });
        });

        // Keep menu open when hovering over the dropdown
        innerMenuWraps.forEach(function(menuWrap) {
            menuWrap.addEventListener('mouseenter', function() {
                clearTimeout(activeMenuTimeout);
                clearTimeout(pendingOpenTimeout);
            });

            menuWrap.addEventListener('mouseleave', function() {
                const menuItem = this.closest('.main-menu-item');

                activeMenuTimeout = setTimeout(function() {
                    if (menuItem) menuItem.classList.remove('hover');
                    menuWrap.classList.remove('level1-visible');
                    menuWrap.classList.add('level1-hidden');
                    closeAllSubMenus();
                }, hoverCloseDelay);
            });
        });

        // Handle hover on inner-menu-items to show corresponding level2 panel
        document.addEventListener('mouseover', function(e) {
            if (isAnyOffcanvasOpen()) return;
            if (!e.target || !e.target.closest) return;

            const item = e.target.closest('.inner-menu-items');
            if (!item) return;

            const link = item.querySelector('.level1-item-link-a');
            if (!link) return;

            const levelId = link.getAttribute('data-level3-id');

            if (levelId) {
                const menuWrap = item.closest('.inner-menu-wrap');
                if (menuWrap) {
                    showLevel2Panel(menuWrap, levelId);

                    // Update hover class
                    const parentList = item.closest('.inner-menu-list');
                    if (parentList) {
                        parentList.querySelectorAll('.inner-menu-items').forEach(function(sibling) {
                            if (sibling !== item) sibling.classList.remove('hover');
                        });
                    }
                    item.classList.add('hover');
                }
            }
        });

        // Handle focusin for accessibility
        document.addEventListener('focusin', function(e) {
            if (isAnyOffcanvasOpen()) return;
            // Check if e.target is an Element (not a text node)
            if (!e.target || !e.target.closest) return;

            const item = e.target.closest('.inner-menu-items');
            if (!item) return;

            const link = item.querySelector('.level1-item-link-a');
            if (!link) return;

            const levelId = link.getAttribute('data-level3-id');

            if (levelId) {
                const menuWrap = item.closest('.inner-menu-wrap');
                if (menuWrap) {
                    showLevel2Panel(menuWrap, levelId);

                    const parentList = item.closest('.inner-menu-list');
                    if (parentList) {
                        parentList.querySelectorAll('.inner-menu-items').forEach(function(sibling) {
                            if (sibling !== item) sibling.classList.remove('hover');
                        });
                    }
                    item.classList.add('hover');
                }
            }
        }, true);

        // Click behavior for toggle items (for mobile/touch devices)
        document.addEventListener('click', function(e) {
            if (isAnyOffcanvasOpen()) return;

            const link = e.target.closest('.sub-menu-link.level1-item-link-a[aria-haspopup="true"]');
            if (!link) return;

            e.preventDefault();
            e.stopPropagation();

            const expanded = link.getAttribute('aria-expanded') === 'true';

            // Toggle aria-expanded
            link.setAttribute('aria-expanded', (!expanded).toString());
            link.classList.toggle('active', !expanded);

            // Toggle corresponding level2 panel
            const levelId = link.getAttribute('data-level3-id');
            if (levelId) {
                const menuWrap = link.closest('.inner-menu-wrap');
                if (menuWrap) {
                    if (!expanded) {
                        showLevel2Panel(menuWrap, levelId);
                    } else {
                        hideAllLevel2Panels(menuWrap);
                    }
                }
            }
        });

        // Click behavior for main menu items (touch devices)
        document.addEventListener('click', function(e) {
            if (isAnyOffcanvasOpen()) return;

            const link = e.target.closest('.main-menu-item.has-children > .level1-item-link > .level1-item-link-a[aria-haspopup="true"]');
            if (!link) return;

            e.preventDefault();
            e.stopPropagation();

            const item = link.closest('.main-menu-item');
            const menuWrap = item.querySelector('.inner-menu-wrap');
            const expanded = link.getAttribute('aria-expanded') === 'true';

            // Close all other menus first
            document.querySelectorAll('.main-menu-item').forEach(function(menuItem) {
                if (menuItem !== item) {
                    menuItem.classList.remove('hover');
                    const wrap = menuItem.querySelector('.inner-menu-wrap');
                    if (wrap) {
                        wrap.classList.remove('level1-visible');
                        wrap.classList.add('level1-hidden');
                    }
                }
            });
            document.querySelectorAll('[aria-expanded="true"]').forEach(function(el) {
                if (el !== link) el.setAttribute('aria-expanded', 'false');
            });

            // Toggle current menu - toggle classes (CSS handles animation)
            link.setAttribute('aria-expanded', (!expanded).toString());
            item.classList.toggle('hover', !expanded);
            if (menuWrap) {
                if (!expanded) {
                    menuWrap.classList.remove('level1-hidden');
                    menuWrap.classList.add('level1-visible');

                    // Open only the level 1 panel; do not auto-activate a level 2 panel
                    resetInnerMenuSelection(menuWrap);
                } else {
                    menuWrap.classList.remove('level1-visible');
                    menuWrap.classList.add('level1-hidden');
                }
            }
        });

        document.addEventListener('shown.bs.offcanvas', function () {
            closeAllMenus();
        });

        // Close menu when clicking outside
        document.addEventListener('click', function(e) {
            if (!e.target.closest('.site-header')) {
                closeAllMenus();
            }
        });

        document.addEventListener('touchstart', function(e) {
            if (!e.target.closest('.site-header')) {
                closeAllMenus();
            }
        });

        // Keyboard navigation support
        initKeyboardNav();
    }

    function resetInnerMenuSelection(menuWrap) {
        if (!menuWrap) return;

        hideAllLevel2Panels(menuWrap);

        menuWrap.querySelectorAll('.inner-menu-items').forEach(function(item) {
            item.classList.remove('hover');
        });

        menuWrap.querySelectorAll('.sub-menu-link.level1-item-link-a[aria-haspopup="true"]').forEach(function(link) {
            link.setAttribute('aria-expanded', 'false');
        });

        const activeLink = menuWrap.querySelector('.sub-menu-link.level1-item-link-a.active[data-level3-id]');
        if (activeLink) {
            const activeLevelId = activeLink.getAttribute('data-level3-id');
            if (activeLevelId) {
                showLevel2Panel(menuWrap, activeLevelId);

                const activeItem = activeLink.closest('.inner-menu-items');
                if (activeItem) {
                    activeItem.classList.add('hover');
                }

                activeLink.setAttribute('aria-expanded', 'true');
                return;
            }
        }

        updateMegaDropdownCardState(menuWrap, false);
    }

    function updateMegaDropdownCardState(menuWrap, hasVisiblePanel) {
        if (!menuWrap) return;

        const megaDropdownCard = menuWrap.querySelector('.mega-dropdown-card');
        if (!megaDropdownCard) return;

        megaDropdownCard.classList.toggle('is-empty', !hasVisiblePanel);
    }

    // Helper function to show a specific level2 panel
    function showLevel2Panel(menuWrap, levelId) {
        // Hide all level2 panels in this menu
        menuWrap.querySelectorAll('.level2').forEach(function(panel) {
            panel.classList.remove('level2-visible');
            panel.classList.add('level2-hidden');
        });

        // Show only the corresponding panel
        const panel = menuWrap.querySelector(".level2[data-level3-id='" + levelId + "']");
        if (panel) {
            panel.classList.remove('level2-hidden');
            panel.classList.add('level2-visible');
            updateMegaDropdownCardState(menuWrap, true);
        } else {
            updateMegaDropdownCardState(menuWrap, false);
        }
    }

    // Helper function to hide all level2 panels
    function hideAllLevel2Panels(menuWrap) {
        if (!menuWrap) return;

        menuWrap.querySelectorAll('.level2').forEach(function(panel) {
            panel.classList.remove('level2-visible');
            panel.classList.add('level2-hidden');
        });

        updateMegaDropdownCardState(menuWrap, false);
    }

    function closeAllMenus() {
        // Remove classes - CSS handles animations
        document.querySelectorAll('.main-menu-item').forEach(function(item) {
            item.classList.remove('hover');
        });
        document.querySelectorAll('.inner-menu-wrap').forEach(function(wrap) {
            wrap.classList.remove('level1-visible');
            wrap.classList.add('level1-hidden');
        });
        document.querySelectorAll('[aria-expanded="true"]').forEach(function(el) {
            el.setAttribute('aria-expanded', 'false');
        });
        closeAllSubMenus();
    }

    function closeAllSubMenus() {
        // Remove/add classes - CSS handles animations
        document.querySelectorAll('.level2-visible').forEach(function(panel) {
            panel.classList.remove('level2-visible');
            panel.classList.add('level2-hidden');
        });
        document.querySelectorAll('.inner-menu-items').forEach(function(item) {
            item.classList.remove('hover');
        });
    }

    function initKeyboardNav() {
        // Enhanced keyboard navigation
        const siteHeaderSubNav = document.querySelector('.site-header-sub-nav');
        if (!siteHeaderSubNav) return;

        siteHeaderSubNav.addEventListener('keydown', function(e) {
            const current = e.target.closest('.level1-item-link-a, .level3-item-link');
            if (!current) return;

            let next, prev;

            switch (e.key) {
                case 'Escape':
                    closeAllMenus();
                    const menuItem = current.closest('.main-menu-item');
                    if (menuItem) {
                        const mainLink = menuItem.querySelector('.main-menu-link');
                        if (mainLink) mainLink.focus();
                    }
                    e.preventDefault();
                    break;

                case 'ArrowDown':
                    const parentLi = current.closest('li, .inner-menu-items');
                    if (parentLi && parentLi.nextElementSibling) {
                        next = parentLi.nextElementSibling.querySelector('a');
                        if (next) next.focus();
                    }
                    e.preventDefault();
                    break;

                case 'ArrowUp':
                    const parentLiUp = current.closest('li, .inner-menu-items');
                    if (parentLiUp && parentLiUp.previousElementSibling) {
                        prev = parentLiUp.previousElementSibling.querySelector('a');
                        if (prev) prev.focus();
                    }
                    e.preventDefault();
                    break;

                case 'ArrowRight':
                    if (current.classList.contains('level1-item-link-a')) {
                        // Move to first level3 link in visible panel
                        const levelId = current.getAttribute('data-level3-id');
                        if (levelId) {
                            const panel = document.querySelector(".level2[data-level3-id='" + levelId + "']");
                            if (panel) {
                                const firstLink = panel.querySelector('.level3-item-link');
                                if (firstLink) firstLink.focus();
                            }
                        }
                    }
                    e.preventDefault();
                    break;

                case 'ArrowLeft':
                    if (current.classList.contains('level3-item-link')) {
                        // Move back to parent level1 link
                        const level2 = current.closest('.level2');
                        if (level2 && level2.previousElementSibling) {
                            const hoverItem = level2.previousElementSibling.querySelector('.inner-menu-items.hover .level1-item-link-a');
                            if (hoverItem) hoverItem.focus();
                        }
                    }
                    e.preventDefault();
                    break;

                case 'Enter':
                case ' ':
                    // Let default behavior handle link clicks
                    if (current.getAttribute('aria-haspopup') === 'true') {
                        current.click();
                        e.preventDefault();
                    }
                    break;
            }
        });

    }

    function MobileMenu() {
        const offcanvas = document.getElementById("site-header-menu-offcanvas");
        if (!offcanvas) return;

        const menuToggleBtn = document.querySelector('.btn-mobile-menu');

        // Prevent backdrop from appearing - remove it immediately if created
        removeBackdropImmediately();

        // Watch for backdrop being added to the DOM and remove it immediately
        observeAndRemoveBackdrop();

        // Initialize dynamic positioning for hamburger menu
        initMobileMenuPositioning(offcanvas);

        // Toggle icon when menu is opening
        offcanvas.addEventListener("show.bs.offcanvas", function() {
            removeBackdropImmediately();
            if (menuToggleBtn) {
                menuToggleBtn.classList.add('menu-open');
            }
        });

        // Toggle icon when menu is closing
        offcanvas.addEventListener("hide.bs.offcanvas", function() {
            if (menuToggleBtn) {
                menuToggleBtn.classList.remove('menu-open');
            }
        });

        // Also remove on shown event as a failsafe
        offcanvas.addEventListener("shown.bs.offcanvas", function() {
            removeBackdropImmediately();
        });

        // Close all nested collapses when offcanvas is hidden
        offcanvas.addEventListener("hidden.bs.offcanvas", function() {
            const collapses = offcanvas.querySelectorAll(".collapse");
            collapses.forEach(function(collapse) {
                const collapseInstance = bootstrap.Collapse.getInstance(collapse);
                if (collapseInstance) {
                    collapseInstance.hide();
                }
            });
            offcanvas.querySelectorAll(".mobile-nav-toggle").forEach(function(toggle) {
                toggle.setAttribute("aria-expanded", "false");
            });
        });

        // Update aria-expanded when collapse is shown
        offcanvas.addEventListener("shown.bs.collapse", function(e) {
            const toggle = e.target.previousElementSibling;
            if (toggle && toggle.classList.contains("mobile-nav-toggle")) {
                toggle.setAttribute("aria-expanded", "true");
            }
        });

        // Update aria-expanded when collapse is hidden
        offcanvas.addEventListener("hidden.bs.collapse", function(e) {
            const toggle = e.target.previousElementSibling;
            if (toggle && toggle.classList.contains("mobile-nav-toggle")) {
                toggle.setAttribute("aria-expanded", "false");
            }
            // Also close any nested collapses
            e.target.querySelectorAll(".collapse").forEach(function(collapse) {
                const collapseInstance = bootstrap.Collapse.getInstance(collapse);
                if (collapseInstance) {
                    collapseInstance.hide();
                }
            });
        });

        // Ensure smooth scrolling in mobile menu content
        const menuContent = offcanvas.querySelector(".mobile-menu-content");
        if (menuContent) {
            offcanvas.addEventListener("shown.bs.collapse", function(e) {
                // Scroll to show the expanded section if needed
                const target = e.target;
                if (target) {
                    setTimeout(function() {
                        const menuContentRect = menuContent.getBoundingClientRect();
                        const targetRect = target.getBoundingClientRect();
                        const scrollTo = menuContent.scrollTop + (targetRect.top - menuContentRect.top) - 20;

                        menuContent.scrollTo({
                            top: scrollTo,
                            behavior: 'smooth'
                        });
                    }, 350); // Wait for collapse animation to complete
                }
            });
        }
    }

    function removeBackdropImmediately() {
        const backdrops = document.querySelectorAll('.offcanvas-backdrop');
        backdrops.forEach(function(backdrop) {
            backdrop.remove();
        });
    }

    function observeAndRemoveBackdrop() {
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1 && node.classList && node.classList.contains('offcanvas-backdrop')) {
                        node.remove();
                    }
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: false
        });
    }

    function initMobileMenuPositioning(offcanvas) {
        let resizeTimeout;
        let mutationObserver;

        function calculateTopOffset() {
            const siteHeaderMain = document.querySelector('.site-header-main');
            if (!siteHeaderMain) return 0;

            const siteHeaderMainRect = siteHeaderMain.getBoundingClientRect();
            const siteHeaderMainBottom = siteHeaderMainRect.bottom;

            return siteHeaderMainBottom;
        }

        function updateOffcanvasPosition() {
            const topOffset = calculateTopOffset();
            const viewportHeight = window.innerHeight;
            const availableHeight = viewportHeight - topOffset;

            offcanvas.style.setProperty('top', topOffset + 'px', 'important');
            offcanvas.style.setProperty('height', availableHeight + 'px', 'important');
        }

        function handleResize() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function() {
                updateOffcanvasPosition();
            }, 100);
        }

        function observeHeaderChanges() {
            const elementsToObserve = [
                document.querySelector('.smartbanner'),
                document.querySelector('.alerts'),
                document.querySelector('.site-header-main'),
                document.querySelector('.cookie-notice')
            ].filter(function(el) { return el !== null; });

            if (elementsToObserve.length === 0) {
                setTimeout(observeHeaderChanges, 500);
                return;
            }

            const config = {
                attributes: true,
                attributeFilter: ['style', 'class'],
                childList: true,
                subtree: true
            };

            mutationObserver = new MutationObserver(function(mutations) {
                let shouldUpdate = false;

                mutations.forEach(function(mutation) {
                    if (mutation.type === 'attributes' && 
                        (mutation.attributeName === 'style' || mutation.attributeName === 'class')) {
                        const target = mutation.target;
                        if (target.classList.contains('alert') ||
                            target.classList.contains('smartbanner') ||
                            target.classList.contains('cookie-notice') ||
                            target.style.display !== undefined) {
                            shouldUpdate = true;
                        }
                    } else if (mutation.type === 'childList') {
                        shouldUpdate = true;
                    }
                });

                if (shouldUpdate) {
                    setTimeout(updateOffcanvasPosition, 50);
                }
            });

            elementsToObserve.forEach(function(element) {
                mutationObserver.observe(element, config);
            });

            const bodyObserver = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    mutation.addedNodes.forEach(function(node) {
                        if (node.nodeType === 1) {
                            if (node.classList && 
                                (node.classList.contains('smartbanner') || 
                                 node.classList.contains('alert') ||
                                 node.classList.contains('cookie-notice'))) {
                                mutationObserver.observe(node, config);
                                setTimeout(updateOffcanvasPosition, 50);
                            }
                        }
                    });
                });
            });

            bodyObserver.observe(document.body, { childList: true, subtree: true });
        }

        updateOffcanvasPosition();
        window.addEventListener('resize', handleResize);
        window.addEventListener('orientationchange', handleResize);

        observeHeaderChanges();

        offcanvas.addEventListener('shown.bs.offcanvas', function() {
            updateOffcanvasPosition();
        });
    }

    return {
        init: init
    };

})();

document.addEventListener('DOMContentLoaded', function () {
    App.SiteHeader.init();
});